//@import dependencies
import React, { ReactElement } from 'react'
import { useSelector } from 'react-redux'
//@end
import { customs } from 'app_config/globals'

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

//@import components
// import HelpDeskCommon from 'app_components/commons/helpDesk/HelpDeskCommon'
import {HeaderCommonLayout} from 'app_components/commons/header'
import Sidebar from 'app_components/modules/sidebar'
import ScreenwrapperModule from 'app_components/modules/screenWrapper/screenwrapper'
// import { FaviconCommonLayout } from 'app_components/commons/helmet/favicon'
//@end

// @import services
import AppService from 'app_services/user/appService'
import { IAppState } from 'app_events/app/types'
// @end

// @ADD Component types
interface IAppComponent {
  children: ReactElement
  app?: IAppState
}

const AppComponent: React.FC<IAppComponent> = (props) => {

  const appService: AppService = new AppService()

  const [imageNavbarSrc, setImageNavbarSrc] = React.useState(require('assets/images/logos/logo_white.png'))
  const [imageNavbarAlt, setImageNavbarAlt] = React.useState('Icontec')
  const [colors] = useColors()

  const auth = useSelector((state: any) => state.auth ? state.auth : null)
  const sidebarComponent = useSelector((state: any) => state.app && state.app.sidebarComponent ? state.app.sidebarComponent : null)

  return(
    <div style={{backgroundColor: colors.background}} className={`app-layout ${auth.user?.data?.screen_mode ? auth.user?.data?.screen_mode : 'light-mode'}`}>
      <div className='wrapper'>
        <aside>
          <Sidebar
            imageNavbarSrc={imageNavbarSrc}
            imageNavbarAlt={imageNavbarAlt}
          />
        </aside>
        <div className='main'>
          <div className={`main-container ${sidebarComponent && sidebarComponent.component ? 'with-sidebar' : ''}`}>
            <div className={sidebarComponent && sidebarComponent.component ? '' : ''}>
              <header>
                <HeaderCommonLayout />
              </header>
              <div className="container-body-page">
                {sidebarComponent && sidebarComponent.component ?
                  <div
                    className="user-info-dashboard-container"
                  >
                    {appService.renderSidebar()}
                  </div>
                : null}
                <ScreenwrapperModule
                  className='data-dashboard-container'
                >
                  <main style={{backgroundColor: 'transparent'}} className={props.app?.sidebar?.collapse ? 'main-unrolled' : ''}>
                    {props.children}
                  </main>
                </ScreenwrapperModule>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppComponent
